import { createReducer } from 'redux-create-reducer'
import {
  CLIENT_LIBRARY_CONTENT_LOAD,
  CLIENT_LIBRARY_CONTENT_LOAD_FAIL,
  CLIENT_LIBRARY_CONTENT_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
export type State = {
  error: Error | null | undefined
  loading: boolean
  loaded: boolean
  items: Record<number, Record<string, any>>
}
const initialState: State = {
  error: null,
  loading: false,
  loaded: false,
  items: {},
}

export const groupsReducer = createReducer<State, any>(initialState, {
  [CLIENT_LIBRARY_CONTENT_LOAD](state) {
    return { ...state, error: null, loading: true }
  },

  [CLIENT_LIBRARY_CONTENT_LOAD_SUCCESS](state, { response }) {
    const items = { ...state.items }
    response.results.forEach(item => {
      items[item.id] = item
    })
    return { ...state, error: null, loaded: true, loading: false, items }
  },

  [CLIENT_LIBRARY_CONTENT_LOAD_FAIL](state, { error }) {
    return { ...state, error, loading: false }
  },
})
